import script from "./QModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./QModal.vue?vue&type=script&setup=true&lang=ts"

import "./QModal.vue?vue&type=style&index=0&id=0c2d852e&lang=scss"

const __exports__ = script;

export default __exports__